import IfHasTikTokAccess from 'components/NoAccessMessage/IfHasTikTokAccess';
import TikTokTrends from './TikTokTrends';
import TikTokTrendsStarter from './TikTokTrendsStarter';

function TikTokTrendsStarterPro(props) {
    return (
        <IfHasTikTokAccess NoAccessComponent={TikTokTrendsStarter}>
            <TikTokTrends />
        </IfHasTikTokAccess>
    );
}

export default TikTokTrendsStarterPro;
